/**
 * 用于弹窗的操作
 */
export default {
  data() {
    return {
      visible: false,
      // 默认配置，可以在弹窗内修改
      openAddConfig: {
        title: '',
        // width: '1200px',
        visible: false,
        hasConfirm: false,
        hasCancel: false,
        hasBtn: true
      },
      openAddBtns: [
        {
          label: '关闭',
          class: 'public-el-button-default',
          method: () => {
            this.openAddConfig.visible = false;
          },
          show: true
        },
        {
          label: '保存',
          type: 'primary',
          class: 'public-el-button',
          method: () => {
            this.submitForm('form');
          },
          show: true
        }
      ]
    };
  },
  methods: {
    // 组件内定义该方法
    // openHandle(...params) {
    //   doSomeThing
    // },
    open(...params) {
      this.openAddConfig.visible = true;
      // 可以覆盖原有的配置
      if (this.coverConfig) {
        this.openAddConfig = Object.assign(this.openAddConfig, this.coverConfig);
      }
      this.openHandle && this.openHandle(...params);
    }
  }
};
